/** 配車板 API の daysToFetch の上限（BE 制限） */
export const MAX_API_DAYS_TO_FETCH = 9

/** 日俯瞰（日モードかつ 7 日以上）とみなす表示日数の下限 */
const DAY_OVERVIEW_MIN_DAYS = 7

/** 日俯瞰で板 API に渡す日数。矢羽根を使わないため BE 最小値に落とす */
const DAY_OVERVIEW_API_DAYS_TO_FETCH = 3

/**
 * 画面の表示日数（daysToFetchAtom）から、板 API に渡す daysToFetch を決める。
 *
 * 日俯瞰（日モードの 7/14/31 日）は矢羽根を描かないので 3 日、
 * それ以外は BE 上限の 9 でクランプする。この値は板クエリのキャッシュキーに
 * 入るため、板を読む側・再取得する側の全員がこの関数を通す必要がある。
 * 各所で組み直すとキーが実キャッシュとずれ、再取得が空振りする。
 */
export const resolveBoardApiDaysToFetch = (
  daysToFetch: number,
  isDayMode: boolean
) =>
  isDayMode && daysToFetch >= DAY_OVERVIEW_MIN_DAYS
    ? DAY_OVERVIEW_API_DAYS_TO_FETCH
    : Math.min(daysToFetch, MAX_API_DAYS_TO_FETCH)
